module.exports = require('./helpers/bundle-url').getBundleURL('ciDtH') + "one_stop.ffd588e5.svg";